import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink py-12" data-id="element-43" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-3 px-5 text-center sm:px-8" data-id="element-44" data-mp="3gezeh7brdx2q">
        <p className="font-display text-lg text-cream" data-id="element-45" data-mp="32o48q3wk3w3d">
          © 2025 Vientre Ligero 60+ · Todos los derechos reservados
        </p>
        <p className="max-w-xl text-sm leading-relaxed text-cream/60" data-id="element-46" data-mp="36q953aee36tp">
          Este producto es digital. Los resultados pueden variar según cada persona.
        </p>
      </div>
    </footer>;
}